import React, { useState, useEffect } from "react"
import "./index.scss"

import Fade from "react-reveal/Fade"

export default function ActiveItemGallery({ items, galleryTitle }) {
  const [activeIndex, setActiveIndex] = useState(0)
  const [newItem, setNewItem] = useState(true)

  if (!items.length) return null

  const activeItem = items[activeIndex]

  return (
    <div className="active-item-gallery">
      {galleryTitle && <h2 className="gallery-title">{galleryTitle}</h2>}
      <div className="wrapper">
        <div className="gallery">
          {items.map(({ key, images, title }, idx) => (
            <div
              key={key}
              onClick={() => {
                setActiveIndex(idx)
                setNewItem(true)
              }}
              className={activeIndex === idx ? "active" : ""}
            >
              <img src={images[0]} alt={title} />
              <span className="menu-title">{title}</span>
            </div>
          ))}
        </div>
        <div className="active-item">
          {activeItem && (
            // <Fade spy={newItem} onReveal={() => setNewItem(false)}>
            <Fade spy={newItem} onReveal={() => setNewItem(false)}>
              <div className="content">
                <h2>{activeItem.title}</h2>
                {activeItem.listItems && activeItem.listItems.length > 0 && (
                  <React.Fragment>
                    {activeItem.listItems.map(({ title, value }, i) => (
                      <p key={i} className="detail">
                        <b>{title}:</b> {value}
                      </p>
                    ))}
                  </React.Fragment>
                )}
                {activeItem.description && (
                  <p className="description">{activeItem.description}</p>
                )}
                {[
                  { title: "Thickness", value: activeItem.thickness },
                  { title: "Factory Size", value: activeItem.factory_size },
                  { title: "Stock Size", value: activeItem.stock_size },
                  { title: "Cut to Size", value: activeItem.cut_to_size },
                  { title: "Edgework Available", value: activeItem.edgework },
                ]
                  .filter(f => f.value)
                  .map(({ title, value }, i) => (
                    <p key={i} className="detail">
                      <b>{title}:</b> {value}
                    </p>
                  ))}
              </div>
              <div className="images">
                <img src={activeItem.images[0]} alt={activeItem.title} />
              </div>
            </Fade>
          )}
        </div>
      </div>
    </div>
  )
}

ActiveItemGallery.defaultProps = {
  items: [],
  galleryTitle: "",
}
